import { Badge } from 'components/badge';
import { FiservRetrievalTitle, FiservRetrievalStatusColor } from 'types';

import { RetrievalStatusBadgeProps } from './types';

export const RetrievalStatusBadge = ({ status }: RetrievalStatusBadgeProps) => (
  <Badge
    text={FiservRetrievalTitle[status]}
    styleType={FiservRetrievalStatusColor[status]}
  />
);
